<template>
  <div class="viedo">
    <div class="video-contener">
      <video controls v-show="v_isShow" ref="video_play">
        <source :src="src" type="video/mp4" />
      </video>
      <div class="video-cover" v-show="p_isShow">
        <img :src="cover" alt="" class="brand_p" />
        <div class="w_375 h_225 pos_a flex j_c_c a_i_c shangjiantou play-b">
          <i
            class="
              font_family
              icon-shangjiantou
              f_s_40
              w_64
              h_64
              l_h_64
              t_a_c
              c_dddddd94
              trans_90
              b_c_00000036 b_r_100
              cursor_p
            "
            @click="onIsShow"
          ></i>
        </div>
      </div>
    </div>

    <div class="btn-close cursor_p" @click="onClose">X</div>
  </div>
</template>

<script>
export default {
  name: "VideoPlay",
  data() {
    return {
      p_isShow: true,
      v_isShow: false,
    };
  },
  methods: {
    onIsShow() {
      this.p_isShow = !this.p_isShow;
      this.v_isShow = !this.v_isShow;
      this.$refs.video_play.play();
    },
    onClose() {
      this.$emit("isComponents");
    },
  },
  props: ["cover", "src"],
};
</script>

<style scoped  lang="scss">
* {
  margin: 0;
  padding: 0;
}
.w_64 {
  width: 64px;
}
.h_64 {
  height: 64px;
}
.l_h_64 {
  line-height: 64px;
}
.viedo {
  background: rgb(35, 37, 38);
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
}
.video-contener {
  width: 1200px;
  height: 640px;
  margin: 50px auto;
  background: black;
}
video {
  width: 100%;
  height: 100%;
}
.btn-close {
  color: white;
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: black;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 20px;
  transition: all 0.3s ease;
  opacity: 0.5;
}
.btn-close:hover {
  opacity: 1;
}
.brand_p {
  width: 100%;
  height: 100%;
}
.video-cover {
  position: relative;
  width: 100%;
  height: 100%;
}
.play-b {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.video-cover:hover {
  .icon-shangjiantou {
    background-color: #fbfbfb69;
    color: #e7e7e7;
  }
}
</style>